import React from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginBottom: 20,
    '& > * + *': {
      marginTop: theme.spacing(3),
    },
  },
}))

const SelectFilter = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Autocomplete
        multiple
        limitTags={2}
        id='multiple-limit-tags'
        options={top100Films}
        getOptionLabel={option => option?.title}
        renderInput={params => (
          <TextField {...params} variant='outlined' placeholder='Send filter' />
        )}
      />
    </div>
  )
}

export default SelectFilter

const top100Films = [
  { title: 'Количество времени, которое пользователь не заходил в систему' },
  { title: 'Количество встреч  у пользователя' },
  { title: 'Отправить всем' },
]
